import React, { useCallback, useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import CampaignNameFiltersModal from "@/components/common/CampaignNameFiltersModal";

type CampaignPlatform = "google" | "meta" | "ga4";

interface CampaignFiltersControlProps {
  customerUuid: string | null;
  accountId?: string;
  onSaved?: () => void;
  defaultPlatform?: CampaignPlatform;
}

const CampaignFiltersControl: React.FC<CampaignFiltersControlProps> = ({
  customerUuid,
  accountId,
  onSaved,
  defaultPlatform = "google",
}) => {
  const [campaignFilterPopoverOpen, setCampaignFilterPopoverOpen] =
    useState(false);
  const [showCampaignNameFilters, setShowCampaignNameFilters] = useState(false);
  const [campaignFilterPlatform, setCampaignFilterPlatform] =
    useState<CampaignPlatform>(defaultPlatform);

  const handleContinue = useCallback(() => {
    setCampaignFilterPopoverOpen(false);
    setShowCampaignNameFilters(true);
  }, []);

  return (
    <>
      <Popover
        open={campaignFilterPopoverOpen}
        onOpenChange={setCampaignFilterPopoverOpen}
      >
        <PopoverTrigger asChild>
          <Button size="sm" variant="outline" className="text-xs">
            Filtro de Campanhas
          </Button>
        </PopoverTrigger>
        <PopoverContent align="end" className="w-72 space-y-3">
          <div className="text-sm font-medium text-foreground">
            Selecione a plataforma
          </div>
          <Select
            value={campaignFilterPlatform}
            onValueChange={(value) =>
              setCampaignFilterPlatform(value as CampaignPlatform)
            }
          >
            <SelectTrigger className="h-8 w-full text-xs">
              <SelectValue placeholder="Plataforma" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="google">Google Ads</SelectItem>
              <SelectItem value="meta">Meta Ads</SelectItem>
              <SelectItem value="ga4">Google Analytics (GA4)</SelectItem>
            </SelectContent>
          </Select>
          <Button size="sm" className="w-full text-xs" onClick={handleContinue}>
            Continuar
          </Button>
        </PopoverContent>
      </Popover>

      <CampaignNameFiltersModal
        open={showCampaignNameFilters}
        onOpenChange={setShowCampaignNameFilters}
        platform={campaignFilterPlatform}
        customerUuid={customerUuid}
        accountId={accountId}
        onSaved={onSaved}
      />
    </>
  );
};

export default CampaignFiltersControl;
